import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DoceboSubscriptionInterface } from '@app/interfaces/_index';
import { User } from '@app/models/_index';
import { environment } from '@environments/environment';
import { catchError, forkJoin, Observable, throwError } from 'rxjs';
import { ApiService } from '../apiService.service';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService extends ErrorHandlerService {
  private subscriptionpathURL = `${environment.beyondApi.url}/subscription`;
  private activeSubscriptions: string[] = [];

  constructor(private http: HttpClient, private apiService: ApiService) {
    super();
  }

  /**
   * Get subscription by subscription id
   *
   * @param id string id for subscription
   * @returns Observable LMS Subscription object
   */
  getSubscription(id: number | string): Observable<DoceboSubscriptionInterface> {
    return this.http
      .get<DoceboSubscriptionInterface>(`${environment.api.kepler.docebo.url}/lp/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<DoceboSubscriptionInterface>('getSubscription'))
      );
  }

  /**
   * Fork Join the subscription service call since there is no way in
   * the LMS to pass in collection of subscription ids, so you have to
   * call it n times
   * NOTE: This is really inefficent since the payload response has courses
   * and other data we do no need.
   * TODO: Need to call new LMS Wrapper API
   *
   * @param ids - numeric ids of subscription ids
   * @returns Observable array of LMS Subscriptions
   */
  getSubscriptions(ids: number[]): Observable<DoceboSubscriptionInterface[]> {
    const subscriptionRequests: Observable<DoceboSubscriptionInterface>[] = [];
    ids.forEach((id) => {
      subscriptionRequests.push(this.getSubscription(id));
    });
    // Fork join the array of subscription id array and return as an array of
    // observables
    return forkJoin(subscriptionRequests);
  }

  /**
   * Return active subscriptions
   * TODO: Need to get the subscription model type here in array
   *
   * @returns - active subscription array promise
   */
  getActiveSubscriptions(currentUser: User): Promise<string[]> {
    if (!currentUser) {
      return Promise.resolve(this.activeSubscriptions);
    }

    const options = {
      userId: `${currentUser.id}`,
    };

    return this.apiService
      .post(`${this.subscriptionpathURL}`, JSON.stringify(options))
      .then((response: any) => {
        if (response && response?.data?.subscriptions) {
          this.activeSubscriptions = response?.data?.subscriptions;
          return Promise.resolve(this.activeSubscriptions);
        } else {
          return Promise.reject(new Error('Unable to get active subscriptions'));
        }
      })
      .catch((err) => {
        return Promise.reject(new Error('Unable to get active subscriptions', err));
      });
  }
}
